import gql from 'graphql-tag'
import { resourceFragment, resourceTypeFragment } from '@/graphql/resource/resourceFragments'

export const RESOURCETYPES = gql`
    query resourceTypes(
        $trashed: Trashed
    ){
        resourceTypes(
            trashed: $trashed
        ){
            ...resourceTypeFragment
        }
    }
    ${resourceTypeFragment}
`
export const RESOURCETYPESRESOURCES = gql`
    query resourceTypes(
        $model: ApplyToModels!
    ){
        resourceTypes{
            ...resourceTypeFragment
            resources(
                model: $model
            ){
                ...resourceFragment
                type{
                    ...resourceTypeFragment
                }
            }
        }
    }
    ${resourceFragment}
    ${resourceTypeFragment}
`

export const RESOURCES = gql`
    query resources(
        $ids: [ID]
        $page: Int
        $first: Int
        $trashed: Trashed
    ){
        resources(
            ids: $ids
            page: $page
            first: $first
            trashed: $trashed
        ){
            data{
                ...resourceFragment
                type{
                    ...resourceTypeFragment
                }
            }
        }
    }
    ${resourceFragment}
    ${resourceTypeFragment}
`

export const RESOURCESSEARCH = gql`
    query resourcesSearch(
        $searchText: String
        $page: Int
        $first: Int
        $trashed: Trashed
    ){
        resourcesSearch(
            searchText: $searchText
            page: $page
            first: $first
            trashed: $trashed
        ){
            data{
                ...resourceFragment
                type{
                    ...resourceTypeFragment
                }
            }
        }
    }
    ${resourceFragment}
    ${resourceTypeFragment}
`